var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWatchFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(0 0.527344)",
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.983 16.5113C10.9222 16.5106 9.90503 16.0889 9.15474 15.339C8.40445 14.5891 7.98232 13.5722 7.981 12.5113C7.981 10.3053 9.776 8.51134 11.983 8.51134C13.0438 8.51214 14.061 8.93376 14.8113 9.68367C15.5615 10.4336 15.9837 11.4505 15.985 12.5113C15.985 14.7173 14.19 16.5113 11.983 16.5113ZM12 4.52734C6.48 4.52734 2 9.36734 2 12.5273C2 15.6133 6.577 20.5273 12 20.5273C17.423 20.5273 22 15.6133 22 12.5273C22 9.36734 17.519 4.52734 12 4.52734Z",
    fill: "#42526E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.5273C13.1046 14.5273 14 13.6319 14 12.5273C14 11.4228 13.1046 10.5273 12 10.5273C10.8954 10.5273 10 11.4228 10 12.5273C10 13.6319 10.8954 14.5273 12 14.5273Z",
    fill: "#42526E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatchFilled);
export default __webpack_public_path__ + "static/media/watch-filled.f1b79c27.svg";
export { ForwardRef as ReactComponent };